__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@securitize/blockchain-microcomponents";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@coreui/react", "4.11.1", () => (Promise.all([__webpack_require__.e(377), __webpack_require__.e(407), __webpack_require__.e(867)]).then(() => (() => (__webpack_require__(7377))))));
			register("@securitize/reactjs-mfe", "0.28.1", () => (Promise.all([__webpack_require__.e(803), __webpack_require__.e(407)]).then(() => (() => (__webpack_require__(8803))))));
			register("@securitize/reactjs-sec-ui", "0.10.4", () => (Promise.all([__webpack_require__.e(821), __webpack_require__.e(407), __webpack_require__.e(98), __webpack_require__.e(355)]).then(() => (() => (__webpack_require__(5821))))));
			register("@securitize/reactjs-sid-utils", "0.5.3", () => (Promise.all([__webpack_require__.e(807), __webpack_require__.e(675)]).then(() => (() => (__webpack_require__(2675))))));
			register("@securitize/web3-hooks", "0.37.0", () => (Promise.all([__webpack_require__.e(152), __webpack_require__.e(407), __webpack_require__.e(98), __webpack_require__.e(144), __webpack_require__.e(812)]).then(() => (() => (__webpack_require__(6191))))));
			register("axios", "0.27.2", () => (__webpack_require__.e(661).then(() => (() => (__webpack_require__(2661))))));
			register("bignumber.js", "9.1.2", () => (__webpack_require__.e(122).then(() => (() => (__webpack_require__(5122))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(346).then(() => (() => (__webpack_require__(1346))))));
			register("clsx", "1.2.1", () => (__webpack_require__.e(49).then(() => (() => (__webpack_require__(2049))))));
			register("goober", "2.1.14", () => (__webpack_require__.e(756).then(() => (() => (__webpack_require__(6756))))));
			register("history", "4.10.1", () => (__webpack_require__.e(420).then(() => (() => (__webpack_require__(9420))))));
			register("js-cookie", "3.0.5", () => (__webpack_require__.e(651).then(() => (() => (__webpack_require__(5651))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(989), __webpack_require__.e(407)]).then(() => (() => (__webpack_require__(3989))))));
			register("react-responsive", "9.0.2", () => (Promise.all([__webpack_require__.e(360), __webpack_require__.e(407)]).then(() => (() => (__webpack_require__(1360))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(396), __webpack_require__.e(407), __webpack_require__.e(162)]).then(() => (() => (__webpack_require__(7396))))));
			register("react-toastify", "6.2.0", () => (Promise.all([__webpack_require__.e(203), __webpack_require__.e(845), __webpack_require__.e(407), __webpack_require__.e(867), __webpack_require__.e(98)]).then(() => (() => (__webpack_require__(8845))))));
			register("react", "18.3.1", () => (__webpack_require__.e(176).then(() => (() => (__webpack_require__(9795))))));
			register("reactstrap", "9.2.2", () => (Promise.all([__webpack_require__.e(203), __webpack_require__.e(44), __webpack_require__.e(407), __webpack_require__.e(867), __webpack_require__.e(943)]).then(() => (() => (__webpack_require__(5044))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};